import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DataManager } from '@syncfusion/ej2-data';
import { TranslateService } from '@ngx-translate/core';
import { saveAs as importedSaveAs } from "file-saver";
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { NotifyService } from '../../services/notify.service';
import { SidebarService } from '../../sidebar/sidebar.service';
import { AuthenService } from '../../services/authen.service';
import { Router } from '@angular/router';
import { UrlParams } from '../../helpers/url-params';
import { MasterBase } from '../../base/master-base';
import * as AppConst from '../../data/test.data';
import { MyImportFileDialogComponent } from "../../dialogs/my-import-file-dialog/my-import-file-dialog";
import { ChangeEventArgs } from '@syncfusion/ej2-buttons';
import { Util } from '../../helpers/global.util';

@Component({
    selector: '',
    templateUrl: './group-hs-member-search.html',
})
export class GroupHSMemberSearchComponent extends MasterBase implements OnInit, OnDestroy {
    @ViewChild('dlgImport') dlgImport: MyImportFileDialogComponent;
    waiting: boolean = false;
   
    

    arrGroupList: Array<any> = [];
    parentIdSearch: number = 1000;
    leader: string = "";
    keyword: string = "";

    nameValueFields: Object = { text: 'Name', value: 'Id' };
    groupParentSource: Array<any> = [];

    constructor(auth: AuthenService, http: HttpService, helper: HelperService, notify: NotifyService, translate: TranslateService, private sidebar: SidebarService, private router: Router) {
        super(auth, http, helper, notify, translate);


    }

    ngOnDestroy() {
    }

    ngOnInit() {
        this.getParentGroupDDL(0);
        this.onSearch();

    }

    onSearch() {

        this.http.get('api/HSGroupMember/SearchGroupHSMember?parentId=' + this.parentIdSearch + '&leader=' + this.leader + '&keyword=' + this.keyword, res => {
            this.arrGroupList = res.Result;
            
        }, null);




        
    }

    getParentGroupDDL(parentId: number) {
        this.http.get('api/HSGroupMember/GetListGroupHSByParent/' + parentId, res => {
            this.groupParentSource = res.Result;
            let noparentOpt = { "Name": "Tất cả", "Id": 1000 };
            this.groupParentSource.push(noparentOpt);
        }, null);
    }

   

    addNew() {
        this.router.navigate(['/group-hs-member-detail']);
    }

    onDelete(id: number) {
        this.helper.confirm('Are you sure you want to remove this item ?', () => {
            this.http.delete(`api/HSGroupMember/RemoveGroupHSMember/${id}`, res => {
                this.grid.refresh();
            });
        });
    }




}
